import React, { useState, useRef } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import cn from 'classnames'
import { get } from 'lodash'

import { formatPrice } from '../utils/formatters'

import CanvasDraw from 'react-canvas-draw'
import GratuityHeader from '../../components/GratuityHeader'
import RoundButton from '../../components/RoundButton'

import { addSignatureToOrder, syncOrderInitiated, syncOrderRequested } from '../../actions/order'

import styles from '../../screens/Signature.module.scss'

const Signature = ({ addSignatureToOrder, orderUuid, total, className, history }) => {
  const classNames = cn(styles.signature, className)
  const [signatureValid, setSignatureValid] = useState(false)
  const signaturePadRef = useRef(null)

  const completeSignature = () => {
    const drawing = get(signaturePadRef, 'current.canvas.drawing')
    const signature = drawing ? drawing.toDataURL('image/svg+xml') : 'Signature Error'

    addSignatureToOrder(orderUuid, signature)
    history.push('/kiosk/order/receipt_selection')
  }

  const clearSignature = () => {
    signaturePadRef.current.clear()
    setSignatureValid(false)
  }

  return (
    <div className={classNames}>
      <GratuityHeader
        className={styles.gratuityHeader}
        primaryText={total}
      />
      <div className={styles.contentContainer}>
        <div className={styles.signaturePadContainer} onTouchEnd={() => setSignatureValid(true)} onMouseUp={() => setSignatureValid(true)}>
          <CanvasDraw
            canvasWidth={900}
            canvasHeight={350}
            className={styles.signaturePad}
            brushRadius={1.5}
            brushColor="#000000"
            catenaryColor="transparent"
            hideGrid
            ref={signaturePadRef}
          />
          <span className={styles.signHereKiosk}></span>
        </div>
        <p className={styles.disclaimer}>I agree to pay the above total amount according to my card issuer agreement.</p>
        <div className={styles.buttonGroup}>
          <RoundButton onClick={clearSignature} text="Clear Signature" className={styles.clearButton} />
          <RoundButton disabled={!signatureValid} onClick={completeSignature} text="Confirm Signature" className={styles.completeButton} />
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  const orderUuid = get(ownProps, 'match.params.orderUuid', state.order.currentOrderId)
  const order = get(state, `order.byId.${orderUuid}`, {})

  const totalInCents = order.amountInCents
  const total = formatPrice(totalInCents)

  return { orderUuid, total }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addSignatureToOrder: (orderUuid, signature) => {
      dispatch(addSignatureToOrder(orderUuid, signature))
      dispatch(syncOrderInitiated(orderUuid))
      dispatch(syncOrderRequested(orderUuid))
    }
  }
}

Signature.propTypes = {
  orderUuid: PropTypes.string,
  total: PropTypes.string,
  addSignatureToOrder: PropTypes.func,
}

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withRouter
)(Signature)
